import InfoPage, { linkClass } from "@/components/InfoPage";
import { CONTACT_EMAIL, INSTAGRAM_HANDLE, INSTAGRAM_URL } from "@/lib/site";

// FAQ copy supplied by AERWEAR (1 Nov 2026). Keep it word for word.
// Per Axel (1 Nov 2026): same-day lines for jewelry and the Mystery Box added; "A full size guide is coming."
// removed while the size guide is hidden (lib/site.js SHOW_SIZE_GUIDE). Reword that answer when the chart is back.
const Email = () => <a href={`mailto:${CONTACT_EMAIL}`} className={linkClass}>{CONTACT_EMAIL}</a>;

const FAQS = [
  { q: "How long does shipping take?", a: <>Your order ships in about 4 weeks. After that, delivery takes 2 to 7 business days. Shipping in the US is free. Jewelry and the Mystery Box ship same day, while stock lasts.</> },
  { q: "Is everything made to order?", a: <>Most pieces are. We make your piece after you order, and we tell you the timing before you buy. Jewelry and the Mystery Box aren't made to order. They ship same day, while stock lasts.</> },
  { q: "How do I track my order?", a: <>When your order ships, we email you a tracking link. Can't find it? Email <Email /> with your order number.</> },
  { q: "What if my order is late?", a: <>We email you before the date passes, with a new ship date and a choice to keep your order or cancel for a full refund.</> },
  { q: "Can I cancel my order?", a: <>Orders can't be cancelled once placed, except if we're late (you can cancel for a full refund) or we sent the wrong item or a defective one.</> },
  { q: "Can I exchange my item?", a: <>Yes, within 30 days of delivery, unworn and unwashed with tags on. Email <Email /> with your order number and the size you want. You pay return shipping unless the mistake was ours.</> },
  { q: "How do I pick my size?", a: <>Email <Email /> with your height, weight and how you like things to fit, and we'll suggest a size.</> },
  { q: "Do you ship internationally?", a: <>Not right now. US addresses only.</> },
  { q: "How do I contact you?", a: <>Email <Email />, or find us on Instagram <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" className={linkClass}>{INSTAGRAM_HANDLE}</a>.</> },
];

export default function FaqPage() {
  return (
    <InfoPage title="FAQ" description="Shipping times, made to order, tracking, exchanges, sizing and how to reach AERWEAR." testid="faq-page">
      {FAQS.map(({ q, a }) => (
        <div key={q} className="border-b border-[#8A8A8A]/20 pb-6">
          <h2 className="text-[15px] font-semibold text-[#F2F0EB]">{q}</h2>
          <p className="mt-2">{a}</p>
        </div>
      ))}
    </InfoPage>
  );
}
